import type { Comment, CommentConfig } from 'component/comment';
import { CharacterCounter } from 'component/text';
import type { Datastore } from 'util/datastore';
import type { Feature } from 'util/stdtypes';

export const LengthLimitFeature: Feature<CommentConfig, {}> = {
    name: 'Comment Length Limit',
    key: 'lengthlimit',
    dev: true,
    providesConfig: {
        commentEditBottomWidgets: [CommentLengthLimit],
        commentPostBlockers: [isCommentLengthBlocked],
    },
};

const minLength = 100;
const maxLength = 1000;

function CommentLengthLimit({ comment }) {
    return <CharacterCounter max={maxLength} min={minLength} text={comment.text} />;
}

function isCommentLengthBlocked(datastore: Datastore, comment: Comment) {
    const length = comment?.text?.length;
    return length < minLength || length > maxLength;
}
